import script from "./infoDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./infoDetails.vue?vue&type=script&setup=true&lang=js"

import "./infoDetails.vue?vue&type=style&index=0&id=79baf7db&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79baf7db"]])

export default __exports__